import type { GetServerSideProps } from "next";

import { ResolvedBaseModel } from "models/baseModel";
import { PDPModelProps } from "models/pdpModel";

import vehicleDetailsPageData from "../../pageHelpers/vehicleDetailsPageData";

export type PDPProps = PDPModelProps &
    ResolvedBaseModel & { recentlyViewedStockBookNumbers: number[] };

export const getServerSideProps: GetServerSideProps<PDPProps> = async (context) => {
    return await vehicleDetailsPageData(context);
};

export { default } from "features/vehicleDetails/templates/pdp/index";
